var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92 6.149l-.772.771 5.439 5.438.771-.771L6.92 6.149z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.4 24 0 18.6 0 12c0-3.164 1.255-6.164 3.545-8.455l.764.764C2.236 6.382 1.091 9.11 1.091 12 1.09 18 6 22.91 12 22.91c6 0 10.91-4.91 10.91-10.91 0-5.836-4.583-10.636-10.364-10.91V6h-1.091V0H12c6.6 0 12 5.4 12 12s-5.4 12-12 12z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/clockIcon.e66e12ea.svg";
export { MemoForwardRef as ReactComponent };